import * as React from 'react';
import { Store } from 'redux';
import { IndexRedirect, Route } from 'react-router';
import { makeGetComponent } from './utils';
import { getChannelRoute } from './ChannelRoute';

export const getEnterpriseRoute = (store: Store<RootState>) => (
  <Route
    path="/enterprise/:companyId"
    getComponent={makeGetComponent('EnterpriseContext/index')}
  >
    <IndexRedirect to="home" />
    <Route path="home" getComponent={makeGetComponent('CompanyLandingPage')} />
    <Route
      path="employees"
      getComponent={makeGetComponent('CompanyEmployeePage')}
    />
    <Route
      path="employees/add"
      getComponent={makeGetComponent('AddEmployeePage')}
    />
    {getChannelRoute(store)}
    <Route path="new" getComponent={makeGetComponent('CreateChannelPage')} />
  </Route>
);



// WEBPACK FOOTER //
// ./app/routers/EnterpriseRoute.tsx